import { filter, get } from "lodash";

// eslint-disable-next-line import/prefer-default-export
export const getHighlightedTags = (
  tags,
  tagConfig,
  flagType = "isPersonBadge"
) => filter(tags, (tag) => get(tagConfig, `${[tag?.type]}.${flagType}`));
